import { Button } from "@/components/ui/button.tsx";
import { Modal, ModalContent } from "@/components/ui/modal.tsx";
import { useI18nextInstance } from "@squide/i18next";
import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { setTeamAdHocFilter, useTeamAdHocFilter } from "../hooks/teamAdHocFilter.ts";
import { useTeamSegment } from "../hooks/useTeamSegment.ts";
import { i18NextInstanceKey } from "../i18n/i18next.ts";
import { SaveAsSegmentDialog } from "./SaveAsSegmentDialog.tsx";

export function TeamFilterActions() {
    const i18nextInstance = useI18nextInstance(i18NextInstanceKey);
    const { t } = useTranslation("TeamFilterActions", { i18n: i18nextInstance });
    const adHocFilter = useTeamAdHocFilter();
    const [, setSegmentId] = useTeamSegment();
    const [isOpen, setIsOpen] = useState(false);
    const [isSaving, setIsSaving] = useState(false);

    const handleClose = useCallback(() => setIsOpen(false), []);
    const handleClear = useCallback(() => setTeamAdHocFilter(null), []);

    const handleSaved = useCallback(
        (newSegmentId: string) => {
            void setSegmentId(newSegmentId);
            setTeamAdHocFilter(null);
            setIsOpen(false);
        },
        [setSegmentId]
    );

    if (!adHocFilter) {
        return null;
    }

    return (
        <div className="flex flex-wrap items-center gap-2">
            <Modal isOpen={isOpen} onOpenChange={setIsOpen}>
                <Button intent="outline" size="lg" name="save-as-segment">
                    {t("saveAsSegment")}
                </Button>
                <ModalContent size="lg" isDismissable={!isSaving} isKeyboardDismissDisabled={isSaving}>
                    <SaveAsSegmentDialog matchType={adHocFilter.matchType} rules={adHocFilter.rules} onBack={handleClose} onSaved={handleSaved} onIsSavingChange={setIsSaving} />
                </ModalContent>
            </Modal>
            <Button intent="plain" size="lg" onPress={handleClear} name="clear-filters">
                {t("clearFilters")}
            </Button>
        </div>
    );
}
